import React from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  Card, 
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText, 
  CardMedia
} from '@mui/material';
import { 
  CheckCircleOutline, 
  Web, 
  PhoneIphone, 
  Cloud,
  Psychology as PsychologyIcon,
  Brush as BrushIcon
} from '@mui/icons-material';

import CloudSvg from "../../assets/cloud_infra.svg";
import WebSvg from "../../assets/web_dev.svg";
import MobileSvg from "../../assets/mobile_dev.svg";
import AiSvg from "../../assets/ai.svg";
import UiUxSvg from "../../assets/ui_ux.svg";
import { FadeInSection } from '../Animations/FadeInAnimation';

const services = [
  {
    title: 'Web Application Development',
    icon: <Web sx={{ fontSize: 40 }} />,
    description: 'Modern web applications built with cutting-edge technologies',
    image: WebSvg,
    features: [
      'Progressive Web Apps (PWA)',
      'Single Page Applications (SPA)',
      'Responsive Design',
      'Cross-browser Compatibility'
    ]
  },
  {
    title: 'Mobile Development',
    icon: <PhoneIphone sx={{ fontSize: 40 }} />,
    description: 'Native and cross-platform mobile solutions',
    image: MobileSvg,
    features: [
      'iOS and Android Development',
      'Cross-platform Solutions',
      'Mobile-first Design',
      'App Store Optimization'
    ]
  },
  {
    title: 'AI Integration & Model Training',
    icon: <PsychologyIcon sx={{ fontSize: 40 }} />,
    description: 'Integrate AI capabilities and custom model training solutions',
    image: AiSvg,
    features: [
      'Machine Learning Integration',
      'Custom Model Training',
      'Neural Network Development',
      'AI-Powered Analytics'
    ]
  },
  {
    title: 'UI/UX Development',
    icon: <BrushIcon sx={{ fontSize: 40 }} />,
    description: 'Modern and intuitive user interface design and development',
    image: UiUxSvg,
    features: [
      'User Interface Design',
      'Interactive Prototypes',
      'Design System Development',
      'User Experience Optimization'
    ]
  },
  {
    title: 'Cloud Solutions',
    icon: <Cloud sx={{ fontSize: 40 }} />,
    description: 'Scalable cloud infrastructure and deployment',
    image: CloudSvg,
    features: [
      'Cloud Migration',
      'Serverless Architecture',
      'Microservices',
      'DevOps Integration'
    ]
  }
];

export const DetailedServices: React.FC = () => (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <FadeInSection delay={0.6}>

        
          <Grid container spacing={4}>
            {services.map((service, index) => (
              <Grid item xs={12} key={index}>
                <Card 
                  elevation={0}
                  sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', md: 'row' },
                    overflow: 'hidden',
                    border: '1px solid',
                    borderColor: 'divider'
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ 
                      width: { md: '40%' },
                      height: { xs: 240, md: 'auto' }
                    }}
                    image={service.image}
                    alt={service.title}
                  />
                  <CardContent sx={{ flex: 1, p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Box sx={{ color: 'primary.main', mr: 2 }}>
                        {service.icon}
                      </Box>
                      <Typography variant="h4" component="h2">
                        {service.title}
                      </Typography>
                    </Box>
                    <Typography variant="subtitle1" paragraph>
                      {service.description}
                    </Typography>
                    <List>
                      {service.features.map((feature, idx) => (
                        <ListItem key={idx} sx={{ px: 0 }}>
                          <ListItemIcon sx={{ minWidth: 36 }}>
                            <CheckCircleOutline color="primary" />
                          </ListItemIcon>
                          <ListItemText primary={feature} />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </FadeInSection>
      </Container>
    </Box>
  );

export default DetailedServices;